import React from 'react';
import { GiBarrier} from 'react-icons/gi'

const Contact = () => {
    return (  
        // <>
        //     <GiBarrier  size={250} style={{marginLeft:"42%"}}/>
        //     <div style={{textAlign:"center"}}>This Page is under Construction.....</div>
        // </>
        <></>
    );
}
 
export default Contact;